// @flow
import {Loader} from 'modules/common/components/Loader';
import React from 'react';

/**
 * Иконка прелоадера с прогрессом c 100% шириной и высотой
 * @returns React-компонент
 */
export const FullLoader = () => (
    <div className="d_f j-c_c a-i_center w_full h_full">
        <Loader big />
    </div>
);
